import { PaginatedQueryResponse } from '@/types/api'
import { ICompanyIndustry } from '@/types/company-industry'
import { ApiService } from './ApiService'

export type { ICompanyIndustry }

export class CompanyIndustryService extends ApiService {
  static GET_PATH = '/company-industries'

  static async getCompanyIndustries(): Promise<
    PaginatedQueryResponse<ICompanyIndustry>
  > {
    return ApiService.get(CompanyIndustryService.GET_PATH)
  }
}
